import Environment from "../environment";

import Api from './ApiService';

import Fidelizacion from "../models/Fidelizacion";
import CodigoPostal from "../models/CodigoPostal";
import Unidad from "../models/Unidad";


export const FidelizacionService = {
    fidelizar: (data, id) => {
        return new Promise((resolve, reject) => {
            let user = JSON.parse(localStorage.getItem('currentUser'));
            return Api.fetch(`${Environment.api}api/unidades-facturaciones/${id}/fidelizacion`, 'PUT', data
            ).then(data => {
                resolve();
            }).catch((error) => {
                    reject(error);
                }
            );
        });
    },

    obtenerFidelizacion: (id) => {
        return new Promise((resolve, reject) => {
            let user = JSON.parse(localStorage.getItem('currentUser'));
            return Api.fetch(`${Environment.api}api/unidades-facturaciones/${id}/fidelizacion`, 'GET'
            ).then(data => {
                resolve(new Fidelizacion(data));
            }).catch((error) => {
                    reject(error);
                }
            );
        });
    },

    obtenerCodigosPostales: () => {
        return new Promise((resolve, reject) => {
            let user = JSON.parse(localStorage.getItem('currentUser'));
            return Api.fetch(`${Environment.api}api/codigos-postales`, 'GET'
            ).then(data => {
                resolve(data.map(i => new CodigoPostal(i)));
            }).catch((error) => {
                    reject(error);
                }
            );
        });
    },

    obtenerCodigosAreas: () => {
        return new Promise((resolve, reject) => {
            let user = JSON.parse(localStorage.getItem('currentUser'));
            return Api.fetch(`${Environment.api}api/codigos-areas`, 'GET'
            ).then(data => {
                resolve(data.map(i => new CodigoPostal(i)));
            }).catch((error) => {
                reject(error);
            }
            );
        });
    },

    obtenerCaracteristicas: (id) => {
        return new Promise((resolve, reject) => {
            let user = JSON.parse(localStorage.getItem('currentUser'));
            return Api.fetch(`${Environment.api}api/codigos-areas/${id}/caracteristicas`, 'GET'
            ).then(data => {
                resolve(data.map(i => new CodigoPostal(i)));
            }).catch((error) => {
                reject(error);
            }
            );
        });
    },
}
